import { ApolloLink } from '@apollo/client';
import { visit } from 'graphql';

/**
 * Apollo Link middleware that transforms ObjectId scalar references to MongoID
 * This allows the secondary GraphQL server to handle MongoDB ObjectIds properly
 */
export class ObjectIdTransformLink extends ApolloLink {
  constructor() {
    super();
  }

  request(operation, forward) {
    // Transform the query/mutation document
    const transformedQuery = this.transformDocument(operation.query);

    // Update operation with transformed query
    operation.query = transformedQuery;

    return forward(operation);
  }

  transformDocument(document) {
    return visit(document, {
      NamedType: {
        enter(node) {
          // Transform ObjectId scalar references to MongoID
          if (node.name.value === 'ObjectId') {
            return {
              ...node,
              name: {
                ...node.name,
                value: 'MongoID'
              }
            };
          }
          return node;
        }
      }
    });
  }
}

/**
 * Factory function to create the ObjectId transform link
 * @returns {ObjectIdTransformLink} The configured transform link
 */
export const createObjectIdTransformLink = () => {
  return new ObjectIdTransformLink();
};
